SlideView = require("views/slide")
device     = require("lib/device")

class VideoView extends SlideView

  events: ->
    "iostap .video":          "toggleVideo"
    "iostap .video-play":     "playVideo"
    "iostap .video-replay":   "restartVideo"
    "iostap .btn-done":       "next"

  render: ->
    @unbindVideoEvents()

    super

    @initializeVideo()
    @listeners = {}

    @setState("loading", "video")

    for evt in ["load", "timeupdate", "error"]
      @listeners[evt] = _.bind(@["onVideo#{_.capitalize(evt)}"], this)
      @getEl("video").addEventListener evt, @listeners[evt]

  initializeVideo: ->
    vid = @el.querySelector(".video")
    @setEl(vid, "video")

  onVideoLoad: ->
    @getEl("video")?.pause()
    @setState("paused", "video")

  onVideoError: ->
    @setState("error", "video")

  onVideoTimeupdate: ->
    if @getEl("video").currentTime is @getEl("video").duration and
       @getEl("video").ended
      @onVideoEnd()

  toggleVideo: ->
    if @getEl("video").paused then @playVideo() else @stopVideo()

  playVideo: ->
    return if @currentState.video is "error"

    @setState("playing", "video")

    @getEl("video").load() if @getEl("video").ended
    @getEl("video").play()

    @trackEvent
      category: "Video"
      action: "Play"
      label: @getVideoName()

  stopVideo: ->
    return if @currentState.video is "error"

    @getEl("video")?.pause()

    @trackEvent
      category: "Video"
      action: "Pause"
      label: @getVideoName()

    window.setTimeout =>
      @setState("paused", "video")
    , 1

  restartVideo: ->
    if @getEl("video").ended
      @getEl("video").load()
    else
      @getEl("video").currentTime = 0

    @playVideo()

  onVideoEnd: ->
    @setState("paused", "video")

  getVideoName: ->
    @getEl("video").src.split("/").slice(-1)[0]

  hide: ->
    @getEl("video")?.pause()
    @onVideoEnd()
    @unbindVideoEvents()

  unbindVideoEvents: ->
    for evt of @listeners
      @getEl("video")?.removeEventListener evt, @listeners[evt]

module.exports = VideoView
